<template>
  <el-col :span="12">
    <el-form-item class="uploaded-label" :label="label">
      <el-upload class="uploader" action="upload" :show-file-list="false" :auto-upload="false"
        :on-change="change">
        <img v-if="content" :src="content" class="image-service" />
        <i v-else  class="fa fa-download fa-2x uploader-icon" aria-hidden="true"></i>
      </el-upload>
    </el-form-item>
  </el-col>
</template>
<script>
import { UploadService } from "@/services/customers/upload.services";
export default {
  name: "UploadComponent",
  props: ['label', 'content'],
  methods: {
    change(file, fileList) { 
      var vm = this;
      UploadService.upload(file, true)
        .then((response) => {
          vm.$emit("uploaded", file.name, response)
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        });
    },
  }
}
</script>
<style scoped>
.image-service {
  width: 208px;
  height: 120px;
  display: block;
}
</style>
